import './InputSearch.scss';
import { Input } from 'antd';

const InputSearch = Input.Search;

export { InputSearch };
